import { PieChart, Pie, Cell } from 'recharts';

function DonutIndicator({
  label,
  value,
  color,
}: {
  label: string;
  value: number;
  color: string;
}) {
  const data = [
    { name: label, value },
    { name: 'rest', value: 100 - value },
  ];

  return (
    <div className="flex flex-col items-center">
      <PieChart width={140} height={140}>
        <defs>
          <linearGradient id={`grad-${label}`} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor={color} stopOpacity={0.9} />
            <stop offset="100%" stopColor={color} stopOpacity={0.6} />
          </linearGradient>
        </defs>
        <Pie
          data={data}
          dataKey="value"
          innerRadius={55}
          outerRadius={65}
          startAngle={90}
          endAngle={-270}
          label // <- activa las labels de Recharts
          labelLine={false} // <- quita la línea
        >
          <Cell fill={`url(#grad-${label})`} />
          <Cell fill="#f3f4f6" /> {/* gris claro para el resto */}
        </Pie>
      </PieChart>
      {/* Leyenda debajo */}
      <div className="mt-2 text-gray-700 text-lg font-semibold">
        {value}%<span className="ml-1 text-sm text-gray-500">{label}</span>
      </div>
    </div>
  );
}

export function OxygenSaturationDonuts({
  min,
  max,
}: {
  min: number;
  max: number;
}) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-10 place-items-center">
      <DonutIndicator label="Min" value={min} color="#13dfb6" />
      <DonutIndicator label="Max" value={max} color="#004e78" />
    </div>
  );
}
